<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5 v-show="!isModal">Edit Anggota</h5>
            </template>
           
            <b-form @submit.prevent="openModalConfirm(requiredForDataKerabatAndPihakLain)">
                <DataIdentitas :dataIdentitas="input.dataIdentitas" :dataJenisIdentitas="jenisIdentitas" @reset="resetDataIdentitas" />
                <!-- <TambahIdentitas :id="id" :dataJenisIdentitas="jenisIdentitas"/> -->
                <DataRekening :id="id" v-if="$companyId == 'PGI'" @getEmail="getEmail"/>
                <DataAnggota :dataAnggota="input.dataAnggota" @reset="resetDataAnggota" @copy="copyDataIdentitas" />
                <DataKerabat :dataKerabat="input.dataKerabat" :vDataKerabat="$v.input.dataKerabat" @reset="resetDataKerabat" />
                <DataPihakLain :dataPihakLain="input.dataPihakLain" :vDataPihakLain="$v.input.dataPihakLain" @reset="resetDataPihakLain" />
                <DataFoto :dataFoto="input.dataFoto" />
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="anggotaUpdateBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-copy" title="Confirm Copy Data Identitas ke Anggota" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengisi bagian Anggota dengan data dari Identitas?" @submit="onCopyFields" />
        <ModalConfirm id="modal-confirm-reset" title="Confirm Reset Kotak Input" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menghapus semua kotak input bagian ini?" @submit="onResetFields" />
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Anggota" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah data anggota ini?" @submit="onSubmit" />
    </div>
</template>

<script>

import DataAnggota from '../../../components/anggota/DataAnggota';
import DataIdentitas from '../../../components/anggota/DataIdentitas';
import DataKerabat from '../../../components/anggota/DataKerabat';
import DataPihakLain from '../../../components/anggota/DataPihakLain';
import DataFoto from '../../../components/anggota/DataFoto';
import DataRekening from '../../../components/anggota/DataRekening.vue'
// import TambahIdentitas from '../../../components/anggota/TambahIdentitas.vue';

import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { string } from 'yargs';


export default {
    mixins: [validationMixin],
    name: 'edit-anggota',
    components: {
        DataAnggota,
        DataIdentitas,
        DataKerabat,
        DataPihakLain,
        DataFoto,
        DataRekening,
        //TambahIdentitas
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            anggota: [],
            form: {
        id_kategori_fpp: null,
        name: null,
      },
            input: {
                dataIdentitas: {
                    nama: '',
                    email: 'Pugindo@gmail.com',
                    jenisIdentitas: null,
                    noIdentitas: '',
                    jenisKelamin: null,
                    statusKawin: null,
                    kewarganegaraan: null,
                    kotaLahir: '',
                    tanggalLahir: '',
                    kotaKtp: {},
                    kecamatanKtp: null,
                    kelurahanDesaKtp: null, 
                    rtKtp: '',
                    rwKtp: '',
                    alamatKtp: '',
                    alamatKerja: '',
                    telpKerja: '',
                    pekerjaanBaru: null,
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                },
                dataAnggota: {
                    pekerjaan: '',
                    // teleponRumahSekarang: '',
                    noHandphoneSekarang: '',
                    // teleponKantorSekarang: '',
                    kotaSekarang: {},
                    kecamatanSekarang: null,
                    kelurahanDesaSekarang: null,
                    rtSekarang: '',
                    rwSekarang: '',
                    alamatSekarang: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false,
                    nomorGang: '',
                    nomorRumah: '',
                    
                },
                dataKerabat: {
                    namaSuamiAtauIstri: '',
                    namaAyah: '',
                    namaIbu: '',
                    noHandphoneSuamiIstri: '',
                    noHandphoneAyah: '',
                    noHandphoneIbu: ''
                },
                dataPihakLain: {
                    namaPihakLain: '',
                    hubunganPihakLain: '',
                    // teleponRumahPihakLain: '',
                    noHandphonePihakLain: '',
                    // teleponKantorPihakLain: '',
                    kotaPihakLain: {},
                    kecamatanPihakLain: null,
                    kelurahanDesaPihakLain: null,
                    rtPihakLain: '',
                    rwPihakLain: '',
                    alamatPihakLain: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                },
                dataFoto: {
                    fotoIdentitas: null,
                    urlFotoIdentitas: null,
                    fotoIdentitasBase64: null,
                    activeFotoIdentitasBase64: null,
                    fotoPendukung1: null,
                    urlFotoPendukung1: null,
                    fotoPendukung1Base64: null,
                    activeFotoPendukung1Base64: null,
                    fotoPendukung2: null,
                    urlFotoPendukung2: null,
                    fotoPendukung2Base64: null,
                    activeFotoPendukung2Base64: null,
                    fotoPendukung3: null,
                    urlFotoPendukung3: null,
                    fotoPendukung3Base64: null,
                    activeFotoPendukung3Base64: null,
                    fotoFormSurvey : null,
                    urlFotoFormSurvey : null,
                    fotoFormSurveyBase64 : null,
                    activeFotoFormSurveyBase64 : null,
                    fotoFormDataBpkb : null,
                    urlFotoFormDataBpkb : null,
                    fotoFormDataBpkbBase64 : null,
                    activeFotoFormDataBpkbBase64 : null,
                } 
            },
            jenisIdentitas: [],
            resetSection: null
        }
    },
    props: {
        isModal: { type: Boolean, default: false},
        idAnggota: { type: Number},
        requiredForDataKerabatAndPihakLain : {type:Boolean}
    },

    validations: {
        input : {
            dataKerabat : {
                namaAyah : {required},
                namaIbu : {required},
                noHandphoneAyah : {required},
                noHandphoneIbu : {required}
            },
            dataPihakLain : {
                namaPihakLain : {required},
                hubunganPihakLain : {required},
                noHandphonePihakLain : {required},
                kelurahanDesaPihakLain : {required},
                rtPihakLain : {required, minLength: minLength(3)},
                rwPihakLain : {required, minLength: minLength(3)},
                alamatPihakLain : {required},
            }
        }
    },
    methods: {

        validateState(name) {
          
      const { $dirty, $error } = this.$v.input.dataKerabat[name];
      return $dirty ? !$error : null;
    },

        //----------------- Fungsi Inisialisasi -----------------

        init() {

            this.initStatus = 0
            
            if(this.isModal){
                this.id = this.idAnggota
            
            }else{
                this.id = this.$route.params.id
            }
            this.id = parseInt(this.id)

            let getJenisIdentitas = this.$axios.get("nasabah/jenis-identitas").then(response => {
                this.jenisIdentitas = []
                for(var data of response.data){
                
                        this.jenisIdentitas.push({value:data.id,text:data.name})
                    
                }
                // this.jenisIdentitas = response.data.map(item => {
                //     return { value: item.id, text: item.name }
                // })

            })

            let getSingleAnggota = this.$axios.get(`nasabah/${this.id}`).then(response => {
    
                this.anggota = response.data
               
                //----------------- Inisialisasi Data KTP -----------------

                this.input.dataIdentitas.nama = this.anggota.nama
                this.input.dataIdentitas.email = this.anggota.email
                this.input.dataIdentitas.jenisIdentitas = this.anggota.jenisIdentitas.id
                this.input.dataIdentitas.noIdentitas = this.anggota.noIdentitas
                this.input.dataIdentitas.jenisKelamin = (this.anggota.detail.jenisKelamin == null) ? null : this.anggota.detail.jenisKelamin
                this.input.dataIdentitas.statusKawin = (this.anggota.detail.statusKawin == null) ? null : this.anggota.detail.statusKawin
                this.input.dataIdentitas.kewarganegaraan = (this.anggota.detail.kewarganegaraan == null) ? null : this.anggota.detail.kewarganegaraan
                this.input.dataIdentitas.kotaLahir = this.anggota.detail.kotaLahir
                this.input.dataIdentitas.alamatKerja = (this.anggota.detail.alamatTempatKerja == null) ? null : this.anggota.detail.alamatTempatKerja
                this.input.dataIdentitas.telpKerja = (this.anggota.detail.teleponTempatKerja == null) ? null : this.anggota.detail.teleponTempatKerja
                this.input.dataIdentitas.pekerjaanBaru = (this.anggota.detail.pekerjaanBaru == null) ? null : this.anggota.detail.pekerjaanBaru.id
                this.input.dataIdentitas.statusKawin = (this.anggota.detail.statusPerkawinan == null) ? null : this.anggota.detail.statusPerkawinan
                this.input.dataIdentitas.tanggalLahir = this.anggota.detail.tanggalLahir
                this.input.dataIdentitas.kotaKtp = this.anggota.detail.kotaKtp
                this.input.dataIdentitas.kecLoading = true
                this.input.dataIdentitas.kelLoading = true

                if(this.anggota.detail.kotaKtp.id != null){
                    this.$axios.get(`area/kecamatan/${this.anggota.detail.kotaKtp.id}`).then(response => {
                        this.input.dataIdentitas.listKecamatan = response.data
                        this.input.dataIdentitas.kecamatanKtp = this.anggota.detail.kecamatanKtp.id
                        this.input.dataIdentitas.kecLoading = false
                        if(this.anggota.detail.kecamatanKtp.id != null){
                            this.$axios.get(`area/kelurahan/${this.anggota.detail.kecamatanKtp.id}`).then(response => {
                                this.input.dataIdentitas.listKelurahan = response.data
                                this.input.dataIdentitas.kelurahanDesaKtp = this.anggota.detail.kelurahanDesaKtp.id
                                this.input.dataIdentitas.kelLoading = false
                            })
                            .catch(error => {
                                console.log(error)
                                this.input.dataIdentitas.kelLoading = false
                                this.input.dataIdentitas.loadKelFail = true

                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.input.dataIdentitas.kecLoading = false
                        this.input.dataIdentitas.loadKecFail = true

                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                    }) 
                }

                this.input.dataIdentitas.rtKtp = this.anggota.detail.rtKtp
                this.input.dataIdentitas.rwKtp = this.anggota.detail.rwKtp
                this.input.dataIdentitas.alamatKtp = this.anggota.detail.alamatKtp
              

                //----------------- Inisialisasi Data Anggota Sekarang -----------------

                this.input.dataAnggota.pekerjaan = this.anggota.detail.pekerjaan
                // this.input.dataAnggota.teleponRumahSekarang = this.anggota.detail.teleponRumahSekarang
                this.input.dataAnggota.noHandphoneSekarang = this.anggota.detail.noHandphoneSekarang
                // this.input.dataAnggota.teleponKantorSekarang = this.anggota.detail.teleponKantorSekarang
                this.input.dataAnggota.kotaSekarang = this.anggota.detail.kotaSekarang
                this.input.dataAnggota.kecLoading = true
                this.input.dataAnggota.kelLoading = true
                this.input.dataAnggota.nomorGang = this.anggota.detail.nomorGang
                this.input.dataAnggota.nomorRumah = this.anggota.detail.nomorRumah

                if(this.anggota.detail.kotaSekarang.id != null){
                    this.$axios.get(`area/kecamatan/${this.anggota.detail.kotaSekarang.id}`).then(response => {
                        this.input.dataAnggota.listKecamatan = response.data
                        this.input.dataAnggota.kecamatanSekarang = this.anggota.detail.kecamatanSekarang.id
                        this.input.dataAnggota.kecLoading = false
                        if(this.anggota.detail.kecamatanSekarang.id != null){
                            this.$axios.get(`area/kelurahan/${this.anggota.detail.kecamatanSekarang.id}`).then(response => {
                                this.input.dataAnggota.listKelurahan = response.data
                                this.input.dataAnggota.kelurahanDesaSekarang = this.anggota.detail.kelurahanDesaSekarang.id
                                this.input.dataAnggota.kelLoading = false
                            })
                            .catch(error => {
                                console.log(error)
                                this.input.dataAnggota.kelLoading = false
                                this.input.dataAnggota.loadKelFail = true

                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.input.dataAnggota.kecLoading = false
                        this.input.dataAnggota.loadKecFail = true

                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                    }) 
                }
                
                this.input.dataAnggota.rtSekarang = this.anggota.detail.rtSekarang
                this.input.dataAnggota.rwSekarang = this.anggota.detail.rwSekarang
                this.input.dataAnggota.alamatSekarang = this.anggota.detail.alamatSekarang


                //----------------- Inisialisasi Data Kerabat -----------------

                this.input.dataKerabat.namaSuamiAtauIstri = this.anggota.detail.namaSuamiAtauIstri
                this.input.dataKerabat.namaAyah = this.anggota.detail.namaAyah
                this.input.dataKerabat.namaIbu = this.anggota.detail.namaIbu
                this.input.dataKerabat.noHandphoneSuamiIstri = this.anggota.detail.noHandphoneSuamiIstri
                this.input.dataKerabat.noHandphoneAyah = this.anggota.detail.noHandphoneAyah
                this.input.dataKerabat.noHandphoneIbu = this.anggota.detail.noHandphoneIbu

                //----------------- Inisialisasi Data Pihak Lain -----------------

                this.input.dataPihakLain.namaPihakLain = this.anggota.detail.namaPihakLain
                this.input.dataPihakLain.hubunganPihakLain = this.anggota.detail.hubunganPihakLain
                // this.input.dataPihakLain.teleponRumahPihakLain = this.anggota.detail.teleponRumahPihakLain
                this.input.dataPihakLain.noHandphonePihakLain = this.anggota.detail.noHandphonePihakLain
                // this.input.dataPihakLain.teleponKantorPihakLain = this.anggota.detail.teleponKantorPihakLain
                this.input.dataPihakLain.rtPihakLain = this.anggota.detail.rtPihakLain
                this.input.dataPihakLain.rwPihakLain = this.anggota.detail.rwPihakLain
                this.input.dataPihakLain.alamatPihakLain = this.anggota.detail.alamatPihakLain
                this.input.dataPihakLain.kecLoading = true
                this.input.dataPihakLain.kelLoading = true

                if (this.anggota.detail.kotaPihakLain.id != null) { 

                    this.input.dataPihakLain.kotaPihakLain = this.anggota.detail.kotaPihakLain

                    this.$axios.get(`area/kecamatan/${this.anggota.detail.kotaPihakLain.id}`).then(response => {
                        this.input.dataPihakLain.listKecamatan = response.data
                        this.input.dataPihakLain.kecamatanPihakLain = this.anggota.detail.kecamatanPihakLain.id
                        this.input.dataPihakLain.kecLoading = false
                        if(this.anggota.detail.kecamatanPihakLain.id != null){
                            this.$axios.get(`area/kelurahan/${this.anggota.detail.kecamatanPihakLain.id}`).then(response => {
                                this.input.dataPihakLain.listKelurahan = response.data
                                this.input.dataPihakLain.kelurahanDesaPihakLain = this.anggota.detail.kelurahanDesaPihakLain.id
                                this.input.dataPihakLain.kelLoading = false
                            })
                            .catch(error => {
                                console.log(error)
                                this.input.dataPihakLain.kelLoading = false
                                this.input.dataPihakLain.loadKelFail = true

                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.input.dataPihakLain.kecLoading = false
                        this.input.dataPihakLain.loadKecFail = true

                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                    }) 

                }

                 //----------------- Inisialisasi Data Foto -----------------

                this.input.dataFoto.urlFotoIdentitas = this.anggota.detail.fotoKtp
                if (this.anggota.detail.fotoPendukung1 != null) this.input.dataFoto.urlFotoPendukung1 = this.anggota.detail.fotoPendukung1
                if (this.anggota.detail.fotoPendukung2 != null) this.input.dataFoto.urlFotoPendukung2 = this.anggota.detail.fotoPendukung2
                if (this.anggota.detail.fotoPendukung3 != null) this.input.dataFoto.urlFotoPendukung3 = this.anggota.detail.fotoPendukung3
                if (this.anggota.detail.fotoFormSurvey  != null) this.input.dataFoto.urlfotoFormSurvey  = this.anggota.detail.fotoFormSurvey 
                if (this.anggota.detail.fotoFormDataBpkb  != null) this.input.dataFoto.urlFotoFormDataBpkb  = this.anggota.detail.fotoFormDataBpkb 

                this.input.dataFoto.activeFotoIdentitasBase64 = this.anggota.detail.fotoKtp
                if (this.anggota.detail.fotoPendukung1 != null) this.input.dataFoto.activeFotoPendukung1Base64 = this.anggota.detail.fotoPendukung1
                if (this.anggota.detail.fotoPendukung2 != null) this.input.dataFoto.activeFotoPendukung2Base64 = this.anggota.detail.fotoPendukung2
                if (this.anggota.detail.fotoPendukung3 != null) this.input.dataFoto.activeFotoPendukung3Base64 = this.anggota.detail.fotoPendukung3
                if (this.anggota.detail.fotoFormSurvey  != null) this.input.dataFoto.activeFotoFormSurveyBase64  = this.anggota.detail.fotoFormSurvey 
                if (this.anggota.detail.fotoFormDataBpkb  != null) this.input.dataFoto.activeFotoFormDataBpkbBase64  = this.anggota.detail.fotoFormDataBpkb 
              


            })

            Promise.all([getJenisIdentitas, getSingleAnggota]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()
            payload.append('id', this.id)

            //----------------- Append Data KTP -----------------

            payload.append('nama', this.input.dataIdentitas.nama)
            
            payload.append('email', (this.input.dataIdentitas.email != null) ?this.input.dataIdentitas.email :'Pugindo@gmail.com')
            payload.append('jenisIdentitasId', this.input.dataIdentitas.jenisIdentitas)
            payload.append('noIdentitas', this.input.dataIdentitas.noIdentitas)
            payload.append('cabangId', 1)
            payload.append('alamatKtp', this.input.dataIdentitas.alamatKtp)
            payload.append('kelurahanDesaKtp', this.input.dataIdentitas.kelurahanDesaKtp)
            payload.append('rtKtp', this.input.dataIdentitas.rtKtp)
            payload.append('rwKtp', this.input.dataIdentitas.rwKtp)
            payload.append('jenisKelamin', this.input.dataIdentitas.jenisKelamin)
            payload.append('statusPerkawinan', this.input.dataIdentitas.statusKawin)
            payload.append('kewarganegaraan', this.input.dataIdentitas.kewarganegaraan)
            payload.append('alamatTempatKerja', this.input.dataIdentitas.alamatKerja)
            payload.append('teleponTempatKerja', this.input.dataIdentitas.telpKerja)
            payload.append('pekerjaanBaru', this.input.dataIdentitas.pekerjaanBaru)
         

            //----------------- Append Data Anggota Sekarang -----------------

            payload.append('alamatSekarang', this.input.dataAnggota.alamatSekarang)
            payload.append('kelurahanDesaSekarang', this.input.dataAnggota.kelurahanDesaSekarang)
            payload.append('rtSekarang', this.input.dataAnggota.rtSekarang)
            payload.append('rwSekarang', this.input.dataAnggota.rwSekarang)
            payload.append('kotaLahir', this.input.dataIdentitas.kotaLahir.id)
            payload.append('tanggalLahir', this.input.dataIdentitas.tanggalLahir)
            // payload.append('teleponRumahSekarang', this.input.dataAnggota.teleponRumahSekarang)
            payload.append('noHandphoneSekarang', this.input.dataAnggota.noHandphoneSekarang)
            // payload.append('teleponKantorSekarang', this.input.dataAnggota.teleponKantorSekarang)
            payload.append('pekerjaan', this.input.dataAnggota.pekerjaan)
            payload.append('nomorGang', this.input.dataAnggota.nomorGang)
            payload.append('nomorRumah', this.input.dataAnggota.nomorRumah)

            //----------------- Append Data Kerabat -----------------

            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaSuamiAtauIstri)) payload.append('namaSuamiAtauIstri', this.input.dataKerabat.namaSuamiAtauIstri)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaAyah)) payload.append('namaAyah', this.input.dataKerabat.namaAyah)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.namaIbu)) payload.append('namaIbu', this.input.dataKerabat.namaIbu)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.noHandphoneSuamiIstri)) payload.append('noHandphoneSuamiIstri', this.input.dataKerabat.noHandphoneSuamiIstri)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.noHandphoneAyah)) payload.append('noHandphoneAyah', this.input.dataKerabat.noHandphoneAyah)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataKerabat.noHandphoneIbu)) payload.append('noHandphoneIbu', this.input.dataKerabat.noHandphoneIbu)

            //----------------- Append Data Pihak Lain -----------------

            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.namaPihakLain)) payload.append('namaPihakLain', this.input.dataPihakLain.namaPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.hubunganPihakLain)) payload.append('hubunganPihakLain', this.input.dataPihakLain.hubunganPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.alamatPihakLain)) payload.append('alamatPihakLain', this.input.dataPihakLain.alamatPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.rtPihakLain)) payload.append('rtPihakLain', this.input.dataPihakLain.rtPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.rwPihakLain)) payload.append('rwPihakLain', this.input.dataPihakLain.rwPihakLain)
            // if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.teleponRumahPihakLain)) payload.append('teleponRumahPihakLain', this.input.dataPihakLain.teleponRumahPihakLain)
            if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.noHandphonePihakLain)) payload.append('noHandphonePihakLain', this.input.dataPihakLain.noHandphonePihakLain)
            // if (this.$helper.isNotNullAndNotEmpty(this.input.dataPihakLain.teleponKantorPihakLain)) payload.append('teleponKantorPihakLain', this.input.dataPihakLain.teleponKantorPihakLain)

            if (this.input.dataPihakLain.kelurahanDesaPihakLain != null) {
                payload.append('kelurahanDesaPihakLain', this.input.dataPihakLain.kelurahanDesaPihakLain)
            }

            //----------------- Append Data Foto -----------------

            if(this.input.dataFoto.activeFotoIdentitasBase64 != null && this.input.dataFoto.activeFotoIdentitasBase64 != this.$baseFilePath+this.input.dataFoto.urlFotoIdentitas)
                payload.append('fotoIdentitas', this.input.dataFoto.activeFotoIdentitasBase64)
            
            if(this.input.dataFoto.activeFotoPendukung1Base64 != null && this.input.dataFoto.activeFotoPendukung1Base64 != this.$baseFilePath+this.input.dataFoto.urlFotoPendukung1)
                payload.append('fotoPendukung1', this.input.dataFoto.activeFotoPendukung1Base64)

            if(this.input.dataFoto.activeFotoPendukung2Base64 != null && this.input.dataFoto.activeFotoPendukung2Base64 != this.$baseFilePath+this.input.dataFoto.urlFotoPendukung2)
                payload.append('fotoPendukung2', this.input.dataFoto.activeFotoPendukung2Base64)
           
            if(this.input.dataFoto.activeFotoPendukung3Base64 != null && this.input.dataFoto.activeFotoPendukung3Base64 != this.$baseFilePath+this.input.dataFoto.urlFotoPendukung3)
                payload.append('fotoPendukung3', this.input.dataFoto.activeFotoPendukung3Base64)
           
            if(this.input.dataFoto.activeFotoFormSurveyBase64  != null && this.input.dataFoto. activeFotoFormSurveyBase64  != this.$baseFilePath+this.input.dataFoto.urlfotoFormSurvey )
                payload.append('fotoFormSurvey', this.input.dataFoto.activeFotoFormSurveyBase64 )

            if(this.input.dataFoto.activeFotoFormDataBpkbBase64  != null && this.input.dataFoto. activeFotoFormDataBpkbBase64  != this.$baseFilePath+this.input.dataFoto.urlFotoFormDataBpkb )
                payload.append('fotoFormDataBpkb ', this.input.dataFoto.activeFotoFormDataBpkbBase64 )

            //----------------- Submit Semua Data -----------------            
            
            this.isSubmitting = true

            this.$axios.post('nasabah/', payload, { timeout: 300000 }).then(response => {
                if(this.isModal == true){
                    this.$helper.toastSucc(this, "Anggota nasabah baru telah berhasil diubah!")
                    let dataModalAnggota = {
                        idAnggota: response.data.id,
                        noAnggota : response.data.noAnggota,
                        noIdentitas: this.input.dataIdentitas.noIdentitas,
                        nama: this.input.dataIdentitas.nama,
                        email: this.input.dataIdentitas.email,
                        noHp: this.input.dataAnggota.noHandphoneSekarang,
                        noRumah: this.input.dataAnggota.teleponRumahSekarang,
                        alamat: this.input.dataAnggota.alamatSekarang,
                        // isComplete: response.data.isComplete
                        isComplete: response.data.isComplete
                    }
                    this.$emit("updateModalAnggota", dataModalAnggota)
                }else{
                    this.$helper.setFlash(`Anggota nasabah baru telah berhasil diubah!`)
                    let path = this.$route.path.split('/')
                    path.pop()
                    path = path.join("/")
                    this.$router.push({ path })
                }
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(isBpkb){
            if(isBpkb == true){
                this.$v.input.$touch();
                if(this.$v.input.dataKerabat.$anyError){
        
                    if(this.$v.input.dataKerabat.namaAyah.$anyError){
                        this.$helper.toastErr(this, "Mohon isi Nama Ayah terlebih dahulu!")
                    }
                    if(this.$v.input.dataKerabat.namaIbu.$anyError){
                        this.$helper.toastErr(this, "Mohon isi Nama Ibu terlebih dahulu!")
                    }
                    if(this.$v.input.dataKerabat.noHandphoneAyah.$anyError){
                        this.$helper.toastErr(this, "Mohon isi No. Hp Ayah terlebih dahulu!")
                    }
                    if(this.$v.input.dataKerabat.noHandphoneIbu.$anyError){
                        this.$helper.toastErr(this, "Mohon isi No. Hp Ibu terlebih dahulu!")
                    }

                   return;
                }
                
                if(this.$v.input.dataPihakLain.$anyError){
                    if(this.$v.input.dataPihakLain.namaPihakLain.$anyError){
                        this.$helper.toastErr(this, "Mohon isi Nama Pihak Lain terlebih dahulu!")
                    }
                    if(this.$v.input.dataPihakLain.hubunganPihakLain.$anyError){
                        this.$helper.toastErr(this, "Mohon isi Hubungan Pihak Lain terlebih dahulu!")
                    }
                    if(this.$v.input.dataPihakLain.noHandphonePihakLain.$anyError){
                        this.$helper.toastErr(this, "Mohon isi No. Hp Pihak Lain terlebih dahulu!")
                    }
                    if(this.$v.input.dataPihakLain.kelurahanDesaPihakLain.$anyError){
                        this.$helper.toastErr(this, "Mohon isi kelurahan pihak lain terlebih dahulu!")
                    }
                    if(this.$v.input.dataPihakLain.rtPihakLain.$anyError){
                        this.$helper.toastErr(this, "Mohon isi RT pihak lain terlebih dahulu! dengan format 3 angka, contoh: 001")
                    }
                    // if(!this.$v.input.dataPihakLain.rtPihakLain.minLength){
                    //     this.$helper.toastErr(this, "Gunakan format 3 angka, contoh: 001")
                    // }
                    if(this.$v.input.dataPihakLain.rwPihakLain.$anyError){
                        this.$helper.toastErr(this, "Mohon isi RW pihak lain terlebih dahulu! dengan format 3 angka, contoh: 001")
                    }
                    if(this.$v.input.dataPihakLain.alamatPihakLain.$anyError){
                        this.$helper.toastErr(this, "Mohon isi Alamat pihak lain terlebih dahulu!")
                    }
                    return;
                }
              
                if(!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kotaLahir)){
                    this.$helper.toastErr(this, "Mohon isi tempat lahir terlebih dahulu!")
                }else if(!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kelurahanDesaKtp)){
                    this.$helper.toastErr(this, "Mohon isi alamat sesuai ktp dengan lengkap terlebih dahulu!")
                }else if(!this.$helper.isNotNullAndNotEmpty(this.input.dataAnggota.kelurahanDesaSekarang)){
                    this.$helper.toastErr(this, "Mohon isi alamat domisili dengan lengkap terlebih dahulu!")
                }else if (this.input.dataFoto.activeFotoIdentitasBase64 == null) {
                    this.$helper.toastErr(this, "Tolong upload foto KTP anda")
                }else {
                    this.$bvModal.show("modal-confirm-edit")
                }
            }
            else {
                if(!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kotaLahir)){
                    this.$helper.toastErr(this, "Mohon isi tempat lahir terlebih dahulu!")
                }else if(!this.$helper.isNotNullAndNotEmpty(this.input.dataIdentitas.kelurahanDesaKtp)){
                    this.$helper.toastErr(this, "Mohon isi alamat sesuai ktp dengan lengkap terlebih dahulu!")
                }else if(!this.$helper.isNotNullAndNotEmpty(this.input.dataAnggota.kelurahanDesaSekarang)){
                    this.$helper.toastErr(this, "Mohon isi alamat domisili dengan lengkap terlebih dahulu!")
                }else if (this.input.dataFoto.activeFotoIdentitasBase64 == null) {
                    this.$helper.toastErr(this, "Tolong upload foto KTP anda")
                }else {
                    this.$bvModal.show("modal-confirm-edit")
                }
            }
            
        },

        onResetFields(){
            if (this.resetSection == 0) {
                this.input.dataIdentitas = {
                    nama: '',
                    email: 'Pugindo@gmail.com',
                    jenisIdentitas: null,
                    noIdentitas: '',
                    kotaLahir: '',
                    tanggalLahir: '',
                    kotaKtp: {},
                    kecamatanKtp: null,
                    kelurahanDesaKtp: null, 
                    rtKtp: '',
                    rwKtp: '',
                    alamatKtp: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                }
            } 
            else if (this.resetSection == 1) {
                this.input.dataAnggota = {
                    pekerjaan: '',
                    teleponRumahSekarang: '',
                    noHandphoneSekarang: '',
                    teleponKantorSekarang: '',
                    kotaSekarang: {},
                    kecamatanSekarang: null,
                    kelurahanDesaSekarang: null,
                    rtSekarang: '',
                    rwSekarang: '',
                    alamatSekarang: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false,
                    nomorGang: '',
                    nomorRumah: '',
                }
            }
            else if (this.resetSection == 2) {
                this.input.dataKerabat = {
                    namaSuamiAtauIstri: '',
                    namaAyah: '',
                    namaIbu: '',
                }
            }
            else if (this.resetSection == 3) {
                this.input.dataPihakLain = {
                    namaPihakLain: '',
                    hubunganPihakLain: '',
                    teleponRumahPihakLain: '',
                    noHandphonePihakLain: '',
                    teleponKantorPihakLain: '',
                    kotaPihakLain: {},
                    kecamatanPihakLain: null,
                    kelurahanDesaPihakLain: null,
                    rtPihakLain: '',
                    rwPihakLain: '',
                    alamatPihakLain: '',
                    listKecamatan: [],
                    listKelurahan: [],
                    kecLoading: false,
                    kelLoading: false
                }
            }

            this.$bvModal.hide("modal-confirm-reset")
        },

        resetDataIdentitas(){
            this.resetSection = 0
            this.$bvModal.show("modal-confirm-reset")
        },

        resetDataAnggota(){
            this.resetSection = 1
            this.$bvModal.show("modal-confirm-reset")
        },

        resetDataKerabat(){
            this.resetSection = 2
            this.$bvModal.show("modal-confirm-reset")
        },

        resetDataPihakLain(){
            this.resetSection = 3
            this.$bvModal.show("modal-confirm-reset")
        },

        onCopyFields(){
            if (Object.keys(this.input.dataIdentitas.kotaKtp).length != 0) {
                this.input.dataAnggota.kotaSekarang = this.input.dataIdentitas.kotaKtp
                this.input.dataAnggota.kecLoading = true
                
                this.$axios.get(`area/kecamatan/${this.input.dataIdentitas.kotaKtp.id}`).then(response => {
                    this.input.dataAnggota.listKecamatan = response.data
                    this.input.dataAnggota.kecLoading = false
                    this.input.dataAnggota.kelLoading = true

                    if (this.input.dataIdentitas.kecamatanKtp != null) {
                        this.input.dataAnggota.kecamatanSekarang = this.input.dataIdentitas.kecamatanKtp
                        

                        this.$axios.get(`area/kelurahan/${this.input.dataIdentitas.kecamatanKtp}`).then(response => {
                            this.input.dataAnggota.listKelurahan = response.data
                            this.input.dataAnggota.kelLoading = false

                            if (this.input.dataIdentitas.kelurahanDesaKtp != null) {
                                this.input.dataAnggota.kelurahanDesaSekarang = this.input.dataIdentitas.kelurahanDesaKtp
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.input.dataAnggota.kelLoading = false
                            this.input.dataAnggota.loadKelFail = true

                            console.log(error.response.data.reason)
                            this.$helper.parseError(this, error)
                        })
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.input.dataAnggota.kecLoading = false
                    this.input.dataAnggota.loadKecFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }

            if (this.input.dataIdentitas.rtKtp != '') this.input.dataAnggota.rtSekarang= this.input.dataIdentitas.rtKtp
            if (this.input.dataIdentitas.rwKtp != '') this.input.dataAnggota.rwSekarang = this.input.dataIdentitas.rwKtp
            if (this.input.dataIdentitas.alamatKtp != '') this.input.dataAnggota.alamatSekarang = this.input.dataIdentitas.alamatKtp

            this.$bvModal.hide("modal-confirm-copy")
        },

        copyDataIdentitas(){
            this.$bvModal.show("modal-confirm-copy")
        },

        getEmail(email){
            this.input.dataIdentitas.email = email
        }
    },

    watch: {

        //----------------- Pantau Data Identitas -----------------

        'input.dataIdentitas.kotaKtp': function(x){
            if (x.id != undefined){
                this.input.dataIdentitas.kecLoading = true
                this.input.dataIdentitas.kecamatanKtp = null
                this.input.dataIdentitas.listKecamatan = []
                this.input.dataIdentitas.kelurahanDesaKtp = null
                this.input.dataIdentitas.listKelurahan = []
                this.$axios.get(`area/kecamatan/${x.id}`).then(response => {
                    this.input.dataIdentitas.listKecamatan = response.data
                    this.input.dataIdentitas.kecLoading = false
                })
                .catch(error => {
                    this.input.dataIdentitas.kecLoading = false
                    this.input.dataIdentitas.loadKecFail = true

                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },

        'input.dataIdentitas.kecamatanKtp': function(id){
            if (id != null){
                this.input.dataIdentitas.kelLoading = true
                this.input.listKelurahan = []
                this.input.dataIdentitas.kelurahanDesaKtp = null
                this.$axios.get(`area/kelurahan/${id}`).then(response => {
                    this.input.dataIdentitas.listKelurahan = response.data
                    this.input.dataIdentitas.kelLoading = false
                })
                .catch(error => {
                    this.input.dataIdentitas.kelLoading = false
                    this.input.dataIdentitas.loadKelFail = true

                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },


        //----------------- Pantau Data Anggota Sekarang -----------------
        
        'input.dataAnggota.kotaSekarang': function(x){
            if (x.id != undefined){
                this.input.dataAnggota.kecLoading = true
                this.input.dataAnggota.kecamatanSekarang = null
                this.input.dataAnggota.listKecamatan = []
                this.input.dataAnggota.kelurahanDesaSekarang = null
                this.input.dataAnggota.listKelurahan = []
                this.$axios.get(`area/kecamatan/${x.id}`).then(response => {
                    this.input.dataAnggota.listKecamatan = response.data
                    this.input.dataAnggota.kecLoading = false
                })
                .catch(error => {
                    this.input.dataAnggota.kecLoading = false
                    this.input.dataAnggota.loadKecFail = true

                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },

        'input.dataAnggota.kecamatanSekarang': function(id){
            if (id != null){
                this.input.dataAnggota.kelLoading = true
                this.input.listKelurahan = []
                this.input.dataAnggota.kelurahanDesaSekarang = null
                this.$axios.get(`area/kelurahan/${id}`).then(response => {
                    this.input.dataAnggota.listKelurahan = response.data
                    this.input.dataAnggota.kelLoading = false
                })
                .catch(error => {
                    this.input.dataAnggota.kelLoading = false
                    this.input.dataAnggota.loadKelFail = true

                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },


        //----------------- Pantau Data Pihak Lain -----------------

        'input.dataPihakLain.kotaPihakLain': function(x){
            if (x.id != undefined){
                this.input.dataPihakLain.kecLoading = true
                this.input.dataPihakLain.kecamatanPihakLain = null
                this.input.dataPihakLain.listKecamatan = []
                this.input.dataPihakLain.kelurahanDesaPihakLain = null
                this.input.dataPihakLain.listKelurahan = []
                this.$axios.get(`area/kecamatan/${x.id}`).then(response => {
                    this.input.dataPihakLain.listKecamatan = response.data
                    this.input.dataPihakLain.kecLoading = false
                })
                .catch(error => {
                    this.input.dataPihakLain.kecLoading = false
                    this.input.dataPihakLain.loadKecFail = true

                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        },

        'input.dataPihakLain.kecamatanPihakLain': function(id){
            if (id != null){
                this.input.dataPihakLain.kelLoading = true
                this.input.listKelurahan = []
                this.input.dataPihakLain.kelurahanDesaPihakLain = null
                this.$axios.get(`area/kelurahan/${id}`).then(response => {
                    this.input.dataPihakLain.listKelurahan = response.data
                    this.input.dataPihakLain.kelLoading = false
                })
                .catch(error => {
                    this.input.dataPihakLain.kelLoading = false
                    this.input.dataPihakLain.loadKelFail = true

                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
            }
        }
    },

    created(){
        this.init()
    }
}
</script>